/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { Autocomplete } from '@mui/material';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { AlertDialog } from '../../Common/AlertDialog';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function EarlyFinishApprovalListing() {
    const screenCode = 'EARLYFINISHAPPROVAL';
    let encrypted = "";
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        submitButtonName: 'Update',
        pageheadername: 'Early Finish Approval'
    });
    const [formData, setFormData] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionCenterID: '0',
        farmerID: '0',
        farmerName: '',
        statusID: 5
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [IsFarmerClear, setIsFarmerClear] = useState(false);
    const [farmer, setFarmer] = useState([]);
    const [requestDetails, setRequestDetails] = useState([]);
    const [approveOpen, setApproveOpen] = useState(false);
    const [formRejectReason, setFormRejectReason] = useState({
        rejectRemark: ''
    })
    const [earlyRequestID, setEarlyRequestID] = useState(0)
    const [farmerPlotID, setFarmerPlotID] = useState(0)
    const [openApproveConfirmation, setOpenApproveConfirmation] = useState(false)
    const [approveRequest, setApproveRequest] = useState([]);
    const [confirmationMessage, setConfirmationMessage] = useState("Crop Early Finish Request Approve")

    const farmerProductPlotsSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center is required'),
        collectionCenterID: Yup.number().notRequired(),
        farmerID: Yup.number().min(1).min(1, 'Please Select Farmer').required('Farmer required'),
        statusID: Yup.number().min(1).min(1, 'Please Select Status').required('Status required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            collectionCenterID: formData.collectionCenterID,
            farmerID: formData.farmerID,
            farmerName: formData.farmerName,
            statusID: formData.statusID
        },

        validationSchema: farmerProductPlotsSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - requestDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetFarmerDetailsByFactoryIDRouteID());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        trackPromise(GetFarmerDetailsByFactoryIDRouteID());
    }, [formik.values.collectionCenterID]);



    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEARLYFINISHAPPROVAL');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }


    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    async function GetFarmerDetailsByFactoryIDRouteID() {
        var res = await services.GetFarmerDetailsByFactoryIDRouteID(formik.values.operationEntityID)
        if (res != null) {
            setFarmer(res);
        }
    }

    async function clearAll() {
        setIsFarmerClear(!IsFarmerClear)
        setValues({
            ...values,
            farmerID: '0',
            statusID: 5
        })
        setRequestDetails([]);
    }

    async function SubmitForm() {
        var res = await services.GetEarlyFinishRequestDetailsForGrid(values);
        if (res.data.length >= 0) {
            setRequestDetails(res.data)
        }
    }

    const filterOptions = (options, { inputValue }) => {
        return options.filter((option) => {
            return (
                option.givenName == null ? "".toLowerCase().includes(inputValue.toLowerCase()) : option.givenName.toLowerCase().includes(inputValue.toLowerCase()) ||
                    option.nic == null ? "".toLowerCase().includes(inputValue.toLowerCase()) : option.nic.toLowerCase().includes(inputValue.toLowerCase())
            );
        });
    };

    function handleSearch(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            var valueV = data["farmerID"];
            var valueV2 = data["givenName"] == null ? "" : data["givenName"];
            var valueV3 = data["firstName"] == null ? "" : data["firstName"];
            var valueV4 = data["nic"] == null ? "" : data["nic"];

            setValues({
                ...values,
                farmerID: valueV.toString(),
                farmerName: valueV2.toString() + " " + valueV3.toString() + " - " + valueV4.toString()
            });
        }
    }

    function handleEarlyFinishRemark(e) {
        const value = e.target.value;
        const containsLetters = /[a-zA-Z]/.test(value);
        
        if (value === '' || containsLetters) {
            setFormRejectReason({
                ...formRejectReason,
                [e.target.name]: value
            })
          }
    }

   

    function handleClick(earlyFinishedCropRequestID, farmerPlotCropMappingID) {
        setEarlyRequestID(earlyFinishedCropRequestID);
        setFarmerPlotID(farmerPlotCropMappingID);
        setApproveOpen(true);
    }

    function handleClickApproveRequest(rowdata) {
        setOpenApproveConfirmation(true);
        setApproveRequest(rowdata)
    }

    function EarlyFinishCancel() {
        setFormRejectReason({
            ...formRejectReason,
            rejectRemark: ''
        })

        setApproveOpen(false)
    }

    const EarlyFinishRequestSend = async () => {
        const { rejectRemark } = formRejectReason;
        const containsLetters = /[a-zA-Z]/.test(rejectRemark);
        const isNotEmpty = rejectRemark.trim() !== '';
    
        if (!isNotEmpty || !containsLetters) {
          toast.error('The input must contain at least one letter and cannot be empty.');
          return;
        }
    
        try {
          const res = await services.RejectEarlyFinishRequest(earlyRequestID, farmerPlotID, rejectRemark);
          if (res.data > 0) {
            toast.success(res.message);
            trackPromise(SubmitForm());
            
            setFormRejectReason({
              ...formRejectReason,
              rejectRemark: '',
            });
          } else {
            toast.error(res.message);
          }
        } catch (error) {
          toast.error('An error occurred while sending the request.');
        } finally {
          setApproveOpen(false);
        }
      };
      
    function confirmRequest(y) {
        if (y) {
            approveEarlyFinishRequest(approveRequest)
        }
    }

    async function approveEarlyFinishRequest(data) {
        var res = await services.ApproveEarlyFinishRequestCrop(data);
        if (res.data > 0) {
            toast.success(res.message);
            trackPromise(SubmitForm());
        } else {
            toast.error(res.message);
        }
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Early Crop Finish Approval   |   FAPS">
                <Container maxWidth>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Fresh Collection Center</MenuItem>
                                        {operationEntityList.map((option) => (
                                            option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <Autocomplete fullWidth
                                        key={IsFarmerClear}
                                        id="farmerID"
                                        options={farmer}
                                        filterOptions={filterOptions}
                                        getOptionLabel={(option) => option.givenName != null ? option.givenName.toString() : null}
                                        onChange={(e, value) => handleSearch(value, e)}
                                        defaultValue={null}
                                        renderInput={(params) =>
                                            <TextField {...params}
                                                variant="outlined"
                                                name="farmerID"
                                                label="Farmer Preferred Name / NIC *"
                                                size="small"
                                                fullWidth
                                                value={formik.values.farmerID}
                                                getOptionDisabled={true}
                                                helperText={touched.farmerID && errors.farmerID}
                                                error={Boolean(touched.farmerID && errors.farmerID)}
                                            />
                                        }
                                    />

                                    <TextField
                                        select
                                        fullWidth
                                        size='small'
                                        label='Early Finish Request Status'
                                        value={formik.values.statusID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('statusID')}
                                        helperText={touched.statusID && errors.statusID}
                                    >
                                        <MenuItem key={0} value={5}>Select All</MenuItem>
                                        <MenuItem value={1}>Pending</MenuItem>
                                        <MenuItem value={2}>Approved</MenuItem>
                                        <MenuItem value={3}>Reject</MenuItem>
                                    </TextField>

                                    <Grid item md={4} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                                                Clear
                                            </Button>
                                            <Button type="submit" color="secondary" variant="outlined">
                                                Search
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br /><br />
                    {requestDetails.length == 0 ?
                        <SearchNotFound searchQuery="Crop Early Finish Request Approve" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '100%' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Plot Name</TableCell>
                                                <TableCell align="center">Crop Name</TableCell>
                                                <TableCell align="center">Early Finish Remark</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Reject Remark</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? requestDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : requestDetails
                                            ).map((row) => (
                                                <TableRow key={row.earlyFinishedCropRequestID}>
                                                    <TableCell align="center" component="th" scope="row">
                                                        {row.plotName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.productName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.remark}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.statusID == 1 ?
                                                            <Chip size="small" label="Pending" style={{ color: 'green' }} /> :
                                                            row.statusID == 2 ? <Chip size="small" label="Approved" style={{ color: 'purple' }} /> :
                                                                <Chip size="small" label="Reject" style={{ color: 'red' }} />
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.rejectRemark != null ? row.rejectRemark : '-'}
                                                    </TableCell>
                                                    {row.statusID == 1 ?
                                                        <TableCell align="center">
                                                            {<IconButton aria-label="reject request" onClick={() => handleClick(row.earlyFinishedCropRequestID, row.farmerPlotCropMappingID)}  >
                                                                <CloseIcon />
                                                            </IconButton>}
                                                            &nbsp;
                                                            {<IconButton aria-label="approve request" onClick={() => handleClickApproveRequest(row)}  >
                                                                <CheckIcon />
                                                            </IconButton>}
                                                        </TableCell> : <TableCell align="center">&nbsp;</TableCell>
                                                    }
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={6}
                                                    count={requestDetails.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }

                    <Dialog fullWidth={true} maxWidth='sm' onClose={EarlyFinishCancel} aria-labelledby="customized-dialog-title" open={approveOpen}>
                        <DialogTitle id="customized-dialog-title" onClose={EarlyFinishCancel}>
                            Early Finish Request Approve!
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid item md={12} xs={12}>
                                <TextField
                                    fullWidth
                                    id="outlined-multiline-static"
                                    label="Early Finish Reject Reason*"
                                    name='rejectRemark'
                                    value={formRejectReason.rejectRemark}
                                    onChange={(e) => { handleEarlyFinishRemark(e) }}
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                />
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button autoFocus onClick={EarlyFinishRequestSend} variant="contained" color="error">
                                Reject
                            </Button>
                            <Button autoFocus onClick={EarlyFinishCancel} variant="outlined" color="secondary">
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmRequest} headerMessage={confirmationMessage} viewPopup={openApproveConfirmation}
                            discription={"Are you sure want to early finish the crop from this plot ?"} setViewPopup={setOpenApproveConfirmation} />
                    </Grid>
                </div>
            </Page>
        </>
    )







}